import { render, staticRenderFns } from "./CRP.vue?vue&type=template&id=67099ee8&scoped=true"
import script from "./CRP.vue?vue&type=script&lang=js"
export * from "./CRP.vue?vue&type=script&lang=js"
import style0 from "./CRP.vue?vue&type=style&index=0&id=67099ee8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67099ee8",
  null
  
)

export default component.exports